export default {
  username: state => state.name,
  userRole: state => state.role,
  userInfo: state => state.userInfo,
  organizationId: state => state.organizationId,
  organizationName: state => state.organizationName,
  organizationAbbreviation: state => state.organizationAbbreviation
};
